import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setShow(true);
  }, []);

  const handleConsent = (value) => {
    localStorage.setItem("cookie_consent", value);
    setShow(false);
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Ми використовуємо cookies</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Ми використовуємо cookies для покращення взаємодії з користувачем.
        Детальніше читайте в{" "}
        <a href="/privacy-policy" rel="noopener noreferrer">
          політиці конфіденційності
        </a>.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleConsent("rejected")}>
          Відхилити
        </Button>
        <Button variant="primary" onClick={() => handleConsent("accepted")}>
          Прийняти
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CookieConsent;
